const ForfeitureTypes = [
  { text: "Never Expires", value: "NEVER" },
  { text: "Expires months after separation", value: "MONTHLY" },
];
export default ForfeitureTypes;
